import { GtmEvents } from '@/gtm/gtm-events';

export class AuthGtmEvents extends GtmEvents {
  eventCategory = 'СобытияАвторизации';

  successAuth({ mode, email }) {
    return this.gtmEvent({
      eventAction: 'Авторизация_УспешнаяАвторизация',
      eventLabel: mode?.toUpperCase(),
      params: { data: { email } },
    });
  }

  successRegistration({ mode, id, name, email, mobilePhone }) {
    return this.gtmEvent({
      eventAction: 'Авторизация_УспешнаяРегистрация',
      eventLabel: mode?.toUpperCase(),
      params: {
        id,
        name,
        email,
        mobilePhone,
      }
    });
  }
}

export const authGtmEvents = new AuthGtmEvents();
